/**
 * Lazy PostHog loader — dynamic import to avoid 153KB in initial bundle.
 * PostHog is loaded on-demand when first needed (after cookie consent).
 */

let _posthog: typeof import('posthog-js').default | null = null
let _loading: Promise<void> | null = null

export async function loadPostHog(): Promise<typeof import('posthog-js').default | null> {
  if (_posthog) return _posthog

  if (!_loading) {
    _loading = import('posthog-js').then((mod) => {
      _posthog = mod.default
    })
  }

  await _loading
  return _posthog
}

export function getPostHog() {
  return _posthog
}
